import { IconButton, Menu, MenuItem, Box, Typography } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { menuProps } from '../constants/styles';
import { useLocale } from '../contexts/locale.context';

const LangSelect = () => {
  const { lang, setLocale } = useLocale();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ mx: 1 }}>
      <IconButton onClick={handleClick} size="medium">
        <Box
          sx={{
            width: 30,
            height: 30,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2">{lang.toUpperCase()}</Typography>
        </Box>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{ sx: menuProps }}
        MenuListProps={{
          sx: { p: 0, li: { m: 1 } },
        }}
      >
        <MenuItem onClick={() => setLocale('es')}>Español</MenuItem>

        <MenuItem onClick={() => setLocale('en')}>English</MenuItem>

        <MenuItem onClick={() => setLocale('uk')}>Українська</MenuItem>

        <MenuItem onClick={() => setLocale('ru')}>Русский</MenuItem>
      </Menu>
    </Box>
  );
};

export default LangSelect;
